import { gql } from '@apollo/client';

export const CREATE_INTEGRATION_CARD = gql`
    mutation ($input: CreateIntegrationCardDTO!) {
        createIntegrationCard(input: $input) {
            message
            integrationCard {
                _id
                name
            }
        }
    }
`;

export const UPDATE_INTEGRATION_CARD = gql`
    mutation ($id: String!, $input: CreateIntegrationCardDTO!) {
        updateIntegrationCard(id: $id, input: $input) {
            message
            integrationCard {
                _id
                name
            }
        }
    }
`;

export const DELETE_INTEGRATION_CARD = gql`
    mutation ($id: String!) {
        deleteIntegrationCard(id: $id) {
            message
        }
    }
`;
